function Diamond2(props)
{
    return(
        <svg className={props.class} style={{...props.style}} viewBox="0 0 480 480"><path d="M360 120 240 0 120 120v240l120 120 120-120V120z"></path></svg>
    )
}

export default Diamond2